<template fluid>
  <div>
    <main-header></main-header>
    <v-container
      :loading="loading"
      id="insire"
      fluid
      grid-list-xl
      class="transparent grey lighten-5 bg ma-0 pa-0 overflow-hidden"
    >
      <div fluid>
        <v-layout row justify-center>
          <v-flex xs12 md4 lg4 sm8>
            <v-form lazy-validation :loading="loading" ref="LoginFormRef">
              <v-card class="LowTransparent">
                <v-progress-linear
                  color="white"
                  height="3"
                  :indeterminate="true"
                  :active="LoginLoading"
                ></v-progress-linear>
                <v-card-title>
                  <img src="../../assets/login.png" class="LoginUserAvatar" />
                </v-card-title>
                <v-card-text>
                  <v-layout>
                    <v-flex xs12>
                      <v-text-field
                        color="pink"
                        :rules="UsernameRule"
                        v-model="user.username"
                        style="text-align:left !important;direction:ltr;"
                        prepend-inner-icon="account_circle"
                        label="نام کاربری "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12>
                      <v-text-field
                        color="pink"
                        :append-icon="show ? 'visibility_off' : 'visibility'"
                        :type="show ? 'text' : 'password'"
                        :rules="PasswordRule"
                        v-model="user.password"
                        style="text-align:left !important;direction:ltr;"
                        prepend-inner-icon="lock"
                        label="رمز عبور "
                        @click:append="show = !show"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12>
                      <v-checkbox color="#4CAF50" v-model="Remember" label="مرا بخاطر بسپار"></v-checkbox>
                      <a color="#E91E63" class="padding-right-10px" @click="ForgotPWD = true">
                        <v-icon color="#E91E63">open_in_new</v-icon>رمز عبور خودرا فراموش کرده ام
                      </a>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12>
                      <v-btn dark @click="login" block color="blue lighten-1" round>
                        <v-icon>done</v-icon>&nbsp;
                        ورود
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>

        <template>
          <v-dialog v-model="ForgotPWD" max-width="450" persistent transition="slide-y-transition">
            <v-card>
              <v-card-title>
                <v-icon color="primary">autorenew</v-icon>&nbsp;
                بازیابی کلمه عبور
                <v-spacer></v-spacer>
                <v-icon @click="ForgotPWD = false">close</v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row align-center justify-center>
                  <div class="text-xs-center">{{MSG}}</div>
                </v-layout>
                <v-form ref="FFFREF">
                  <v-layout row wrap align-center justify-center>
                    <v-flex xs12 lg12 xl12 sm12 md12>
                      <v-text-field
                        v-model="FFPHONE"
                        :rules="FFPHONERULES"
                        :mask="IMASK"
                        solo
                        :prepend-inner-icon="IICON"
                        class="ltr"
                        :prefix="IPREFIX"
                        :placeholder="IPLC"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 lg12 xl12 sm12 md12 align-center justify-center>
                      <v-btn color="primary" block @click="FFRECOVERY" :loading="FFBTNLOADING">
                        <v-icon>keyboard_arrow_right</v-icon>&nbsp;
                        مرحله بعد
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 lg12 xl12 sm12 md12 v-if="ShowInterval">
                      <div class="text-xs-center">
                        ارسال مجدد بعد از (
                        <span id="timer" class="pink--text">00:59</span> )
                      </div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-dialog>
        </template>
        <v-layout row justify-center>
          <v-dialog v-model="loading" persistent fullscreen content-class="loading-dialog">
            <v-container fill-height>
              <v-layout row justify-center align-center>
                <v-progress-circular
                  v-if="trying"
                  indeterminate
                  :size="70"
                  :width="7"
                  color="purple"
                ></v-progress-circular>
                <v-snackbar color="error" v-model="failed"> {{message}} </v-snackbar>
              </v-layout>
            </v-container>
          </v-dialog>
        </v-layout>
        <v-footer class="pa-4 footer">
          <v-layout justify-center centered>
            <div>تمامی حقوق برای سافاری محفوظ است {{ new Date().getFullYear() }}</div>
          </v-layout>
        </v-footer>
      </div>
    </v-container>
  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import MainHeader from "@/components/index/MainHeader";
import LoginServices from "@/services/LoginServices";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      message: '',
      trying: false,
      failed: false,
      name: "Loading",
      user: {
        username: null,
        password: null
      }
    };
  },
  components: {
    MainHeader
  },
  computed: {
    ...mapState(["isUserLoggedIn"])
  },
  methods: {
    async login() {
      try {
        await setTimeout(() => {
          this.failed = true;
          this.message = 'سرور کند است و پاسخ نمیدهد!'
          setTimeout(() => {
            this.$router.go();
          }, 1200);
        },18800);
        this.loading = true;
        this.trying = true;
        console.log(this.user)
        let response = await LoginServices.login(this.user);
        console.log(response);
        this.$store.dispatch("setToken", response.data.token);
        this.$store.dispatch("setUser", response.data.agent);
        this.$router.go(-1);
        this.trying = false;
      } catch (error) {
        console.log(error);
        this.failed = true;
        this.message = 'ورود ناموفق!دوباره تلاش کنید'
        setTimeout(() => {
          this.$router.go();
        }, 1200);
      }
    }
  },
  mounted() {
    if (!!this.$store.state.isUserLoggedIn) {
      this.$router.push({ name: "index" });
    }
  }
};
</script>

<style scoped>
.bg {
  background-image: url("../../assets/er.jpg");
  background-position: center;
  background-size: cover;
  overflow-y: hidden !important;
  width: 100%;
  height: 800px;
  max-height: 900px;
}

@media (max-width: 600px) {
  .bg-phone {
    display: none;
  }
}

.padding-right-10px {
  padding-right: 8px;
}

.title-post {
  font-size: 18px;
  color: dimgrey;
}

.top-session {
  float: left;
  direction: ltr;
}
.LoginUserAvatar {
  width: 100px;
  height: 100px;
  display: block;
  margin: auto;
}

.footer {
  bottom: 0;
  position: absolute;
  width: 100%;
  color: white;
}
.footer:fullscreen {
  bottom: 50px;
}
.v-progress-linear {
  -moz-transform: scale(1, -1);
  -webkit-transform: scale(1, -1);
  -o-transform: scale(1, -1);
  -ms-transform: scale(1, -1);
  transform: scale(1, -1);
}
</style>